import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { first } from 'rxjs';
import { DatePipe } from '@angular/common';
import { environment } from './../../../../../environments/environment';
import { OrderTermsJeevesComponent } from 'gung-standard-jeeves';
import { AuthService, SelectedCustomerService, TableRecord, AvailabilityService } from 'gung-standard';

@Component({
    selector: 'ref-order-terms-jeeves',
    templateUrl: './ref-order-terms-jeeves.component.html',
    styleUrls: ['./ref-order-terms-jeeves.component.scss'],
    standalone: false
})
export class RefOrderTermsJeevesComponent extends OrderTermsJeevesComponent implements OnInit {
  isRef = environment.projectName === 'ref';
  customerKusBetkod: string;

  public isCapstone: boolean = environment.projectName === 'capstone';
  public newCustomerOrder: boolean = false;

  constructor(
    protected authService: AuthService,
    protected formBuilder: FormBuilder,
    protected datePipe: DatePipe,
    protected availabilityService: AvailabilityService,
    protected selectedCustomerService: SelectedCustomerService
  ) {
    super(authService, formBuilder, datePipe, availabilityService);
    this.selectedCustomerService
      .getSelectedCustomer()
      .pipe(first())
      .subscribe(selectedCustomer => {
        this.customerKusBetkod = selectedCustomer.extra.kus.betkod;
      });
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.isCapstone) {
      this.newCustomerOrder = this.checkout?.extra?.oh?.salestype === '20';
    }
  }

  protected filterPaymentTerms(customerKusBetkod, option: { key: string; value: string | TableRecord }): boolean {
    return (
      option.key === '10' ||
      option.key === '20' ||
      option.key === '30' ||
      option.key === '40' ||
      (customerKusBetkod ? option.key === customerKusBetkod : false)
    );
  }

  protected assignFormValues(formGroup: FormGroup) {
    super.assignFormValues(formGroup);

    if (this.isCapstone) {
      if (this.newCustomerOrder) {
        this.checkout.extra.oh.salestype = '20';
      } else if (!this.newCustomerOrder && this.checkout?.extra?.oh?.salestype === '20') {
        delete this.checkout.extra.oh.salestype;
      }
    }
  }
}
